<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.5 2.5C21.1569 2.5 22.5 3.84315 22.5 5.5V19.5C22.5 21.1569 21.1569 22.5 19.5 22.5H5.5C3.84315 22.5 2.5 21.1569 2.5 19.5V5.5C2.5 3.84315 3.84315 2.5 5.5 2.5H19.5ZM10.792 12.998L6.06543 18.5938H8.24902L11.8242 14.3613L14.999 18.5547H19.2578L14.0703 11.7021L18.5449 6.40625H16.3613L13.0381 10.3398L10.001 6.32812H5.74219L10.792 12.998ZM16.9072 17.3867H15.5811L8.09277 7.49609H9.41895L16.9072 17.3867Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgTwitter',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
